import { AddressSettings } from "./AddressSettings";

export default AddressSettings;